export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <a href="#hero" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-primary-400 whitespace-nowrap">
                韩漫
              </span>
            </a>
            <p className="text-sm text-foreground-300 leading-relaxed">
              国内领先的<strong className="text-foreground-200">韩漫免费在线观看</strong>平台，提供<strong className="text-foreground-200">免费韩漫大全</strong>资源，致力于让每一位读者享受<strong className="text-foreground-200">韩漫在线免费阅读</strong>的乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '热门推荐', href: '#cards' },
                { label: '热门排行', href: '#ranking' },
                { label: '主题索引', href: '#index' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">热门题材</h4>
            <ul className="space-y-2.5">
              {['恋爱韩漫', '奇幻韩漫', '动作韩漫', '悬疑韩漫', '古风韩漫'].map((item) => (
                <li key={item}>
                  <a
                    href="#cards"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              与多家韩国漫画平台及版权方建立合作关系，持续为读者带来优质正版韩漫内容。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2024-2026 韩漫 - 免费韩漫在线观看平台. 本站内容仅供学习交流使用.
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
              联系我们
            </a>
            <a href="#faq" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
              常见问题
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}